let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ihK2n")).then(() => parcelRequire('7GkKZ'));